const getCookieDomainFromHost = (host?: string): string | null => {
  if (!host || host === 'localhost') {
    return null;
  }

  return host;
};

export const setUserCookie = (userToken: string, host?: string) => {
  const domain = getCookieDomainFromHost(host);
  const maxAge = 7 * 24 * 60 * 60;
  let user_cookie = `policy_pilot_user=${userToken}; path=/; max-age=${maxAge};`;

  if (domain) {
    user_cookie = `${user_cookie} domain=${domain};`;
  }

  document.cookie = user_cookie;
};

export const deleteUserCookie = (host?: string) => {
  const domain = getCookieDomainFromHost(host);
  let user_cookie = `policy_pilot_user=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

  if (domain) {
    user_cookie = `${user_cookie} domain=${domain};`;
  }

  document.cookie = user_cookie;
};

export const hasUserCookie = (): boolean => {
  return document.cookie
    .split(';')
    .some((cookie) => cookie.trim().startsWith('policy_pilot_user='));
};
